import "./todos.scss";
import { useState } from "react";
import { toast } from "react-toastify";
import { formatJalaliDateFa } from "../../utils/formatJalaliDateFa";
import { FaToEnDigits } from "../../utils/faToEnDigits";
import { DeleteTodo, UpdateTodoStatus } from "../../services/todoService";
import IconButton from "../iconButton/iconButton";
import EditTodoComponent from "../editTodo/editTodo";
import Confirm from "../confirm/confirm";
import EditIcon from "../../assets/images/edit.svg";
import DeleteIcon from "../../assets/images/delete.svg";
import LoadingIcon from "../../assets/images/loadingGreen16.svg";

export default function Todos({todos, onManipulation, currentDate}) {
  const [editTodoId, setEditTodoId] = useState("");
  const [deleteTodoId, setDeleteTodoId] = useState("");
  const [statusLoading, setStatusLoading] = useState(null);
  const [deletLoading, setDeletLoading] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const date = FaToEnDigits(currentDate.format("YYYYMMDD"));
  
  const handleDeleteTodo = async (todoId) => {
    setDeleteTodoId(todoId);
    if (showConfirmation) {
       try {
        setDeletLoading(deleteTodoId);
        await DeleteTodo(deleteTodoId);
        setDeletLoading(null);
        setShowConfirmation(false);
        onManipulation();
      } catch (err) {
        setDeletLoading(null);
        toast.error(err.error, { toastId: "error" });
      }
    } else {
      setShowConfirmation(true);
    }
  }


  const updateTodoStatus = async (todoId, done) => {
    try {
      setStatusLoading(todoId);
      await UpdateTodoStatus(todoId, done, date);
      setStatusLoading(null);
      onManipulation();
    } catch (err) {
      setStatusLoading(null);
      toast.error(err.error, { toastId: "error" });
    }
  }

  const afterEditTodo = () => {
    setEditTodoId("");
    onManipulation();
  }

  return (
    <div className="todos">
      <Confirm
        message="آیا از حذف این مورد اطمینان دارید؟"
        display={showConfirmation}
        onConfirm={() => handleDeleteTodo()}
        onCancel={() => setShowConfirmation(false)}
        loading={deletLoading}
      />   
      {todos.length > 0 && 
        todos.map( (todo) => {
          return (
            statusLoading === todo.ID ? (
            <img src={LoadingIcon} alt="loading" className="loadingIcon" key={todo.ID} />
            ) : (
              <div className={`todoContent ${editTodoId === todo.ID ? "editing" : ""} ${todo.done ? "done" : ""} ${todo.priority === 1 ? "high" : todo.priority === 2 ? "medium" : "low"}`}
                key={todo.ID}
              >
                {editTodoId === todo.ID ? (
                  <EditTodoComponent currentDate={currentDate} text={todo.todo} todoId={todo.ID} currentPriority={todo.priority} onCancel={() => afterEditTodo("")}  afterEditTodo={afterEditTodo}/>
                ) : (
                  <div className="todo">
                    <div className="checkboxWrapper" onClick={() => updateTodoStatus(todo.ID, !todo.done)}>
                      <div className="status"></div>
                      <div className="todoText">
                        <p>
                          {todo.todo}
                          {todo.doneAt > date && <span className="todoDoneDate"> انجام شده در {formatJalaliDateFa(todo.doneAt)}</span>}
                          {todo.date < date && <span className="todoDoneDate"> ایجاد شده در {formatJalaliDateFa(todo.date)}</span>}
                        </p>
                        
                      </div>
                    </div>
                    <div className="todoIconWrapper">
                      {!todo.done && <IconButton icon={EditIcon} tooltip="ویرایش" onClick={() => setEditTodoId(todo.ID)} className="editRemoveIcon"/>}
                      <IconButton icon={DeleteIcon} tooltip="حذف" onClick={() => handleDeleteTodo(todo.ID)} loading={deletLoading === todo.ID} className="editRemoveIcon"/>
                    </div>
                  </div>
                )}
              </div>
            )
          )
        })
      }
    </div>
  );
}
